// extracted by mini-css-extract-plugin
export default {"overlay":"commonmodal_overlay__tZ1bs","modal":"commonmodal_modal__KwpJJ"};